import React from 'react';
import { Link } from 'react-router-dom';
import { useCategories } from '../context/CategoriesContext';
import { useSettings } from '../context/SettingsContext';
import { resolveImageUrl } from './ImageUpload';

const Categories = () => {
  const { categories } = useCategories();
  const { settings } = useSettings();
  if (!categories.length) return null;
  return (
    <section id="categories" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-20">
      <div className="flex items-end justify-between mb-7 sm:mb-10">
        <div className="reveal">
          <div className="text-[10px] sm:text-[11px] font-bold tracking-[0.2em] text-[#0078D4] uppercase mb-2">
            {settings?.categories_eyebrow || 'Product lines'}
          </div>
          <h2 className="layout-section-title font-display text-3xl sm:text-4xl lg:text-5xl text-slate-900">
            {settings?.categories_heading || 'Catalogue overview'}
          </h2>
          <p className="layout-page-subtitle text-sm sm:text-base text-slate-500 mt-2 max-w-lg">
            {settings?.categories_desc || ''}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
        {categories.map((c, i) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className={`group relative rounded-2xl sm:rounded-3xl overflow-hidden card-lift bg-white border border-slate-100 reveal reveal-delay-${i + 1}`}
          >
            <div
              className="relative aspect-square p-4 sm:p-5 flex flex-col"
              style={{ background: `linear-gradient(165deg, ${c.bg} 0%, #ffffff 75%)` }}
            >
              <div className="flex-1 flex items-center justify-center my-1">
                <img
                  src={resolveImageUrl(c.image)}
                  alt={c.name}
                  className="w-auto object-contain drop-shadow-2xl group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-500"
                  style={{ maxHeight: '78%' }}
                />
              </div>

              <div>
                <div className="font-display text-lg sm:text-xl lg:text-2xl text-slate-900 leading-tight category-tile-name">
                  {c.name}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Categories;
